"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ViewportGlobalAccessObject_boundingBoxCreated, _ViewportGlobalAccessObject_initialized, _ViewportGlobalAccessObject_settingsAssigned, _ViewportGlobalAccessObject_viewportCreationDefinition, _ViewportGlobalAccessObject_viewportEngine, _ViewportGlobalAccessObject_busy, _ViewportGlobalAccessObject_environmentMapLoaded;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewportGlobalAccessObject = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
class ViewportGlobalAccessObject {
    constructor(viewportEngine, viewportCreationDefinition) {
        _ViewportGlobalAccessObject_boundingBoxCreated.set(this, new viewer_shared_services_1.StatePromise());
        _ViewportGlobalAccessObject_initialized.set(this, new viewer_shared_services_1.StatePromise());
        _ViewportGlobalAccessObject_settingsAssigned.set(this, new viewer_shared_services_1.StatePromise());
        _ViewportGlobalAccessObject_viewportCreationDefinition.set(this, void 0);
        _ViewportGlobalAccessObject_viewportEngine.set(this, void 0);
        _ViewportGlobalAccessObject_busy.set(this, []);
        _ViewportGlobalAccessObject_environmentMapLoaded.set(this, new viewer_shared_services_1.StatePromise());
        __classPrivateFieldSet(this, _ViewportGlobalAccessObject_viewportEngine, viewportEngine, "f");
        __classPrivateFieldSet(this, _ViewportGlobalAccessObject_viewportCreationDefinition, viewportCreationDefinition, "f");
    }
    get boundingBoxCreated() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_boundingBoxCreated, "f");
    }
    get busy() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_busy, "f");
    }
    get environmentMapLoaded() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_environmentMapLoaded, "f");
    }
    set environmentMapLoaded(value) {
        __classPrivateFieldSet(this, _ViewportGlobalAccessObject_environmentMapLoaded, value, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").id;
    }
    get initialized() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_initialized, "f");
    }
    get sessionSettingsId() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").sessionSettingsId;
    }
    get sessionSettingsMode() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").sessionSettingsMode;
    }
    get settingsAssigned() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_settingsAssigned, "f");
    }
    get viewportCreationDefinition() {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportCreationDefinition, "f");
    }
    applySettings(sections, settingsEngine, updateViewport) {
        return __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").applySettings(sections, settingsEngine, updateViewport);
    }
    assignSettingsEngine(settingsEngine) {
        __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").assignSettingsEngine(settingsEngine);
    }
    displayErrorMessage(message) {
        __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").displayErrorMessage(message);
    }
    reset() {
        __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").reset();
    }
    saveSettings() {
        __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").saveSettings();
    }
    update(id) {
        __classPrivateFieldGet(this, _ViewportGlobalAccessObject_viewportEngine, "f").update(id);
    }
}
exports.ViewportGlobalAccessObject = ViewportGlobalAccessObject;
_ViewportGlobalAccessObject_boundingBoxCreated = new WeakMap(), _ViewportGlobalAccessObject_initialized = new WeakMap(), _ViewportGlobalAccessObject_settingsAssigned = new WeakMap(), _ViewportGlobalAccessObject_viewportCreationDefinition = new WeakMap(), _ViewportGlobalAccessObject_viewportEngine = new WeakMap(), _ViewportGlobalAccessObject_busy = new WeakMap(), _ViewportGlobalAccessObject_environmentMapLoaded = new WeakMap();
//# sourceMappingURL=ViewportGlobalAccessObject.js.map